export interface SeoFields {
    /** Optional description specific for SEO purposes, limit 170 characters. */
    seoDescription?: string | null;

    /** Optional title specific for SEO purposes, limit 256 characters. */
    seoTitle?: string | null;
}
